import r from 'render-dom';
import styled from 'styled-components';

import NewEggHint from 'images/newegg_hint.png';

const Small = styled.small`
    display: inline-block;
    margin-top: 5px;
`;

export const marketplaces = [
    {
        label: 'Amazon',
        marketplaceIdHint: r.div([
            'https://www.amazon.com/My-Cool-Product/dp/',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://www.amazon.com/My-Cool-Product/dp/',
                r.b('B05KDK28Z8'),
            ]),
        ]),
        marketplaceUrlHint: 'https://www.amazon.com/Super-Cool-Product/dp/B05D6ZG27D',
        productType: 'product',
        reviewURL: (listing) => listing.getIn(['metadata', 'asin']) && `https://smile.amazon.com/review/review-your-purchases/listing?&pinnedAsins=${listing.getIn(['metadata', 'asin'])}`,
        value: 'https://amazon.com',
    },
    {
        label: 'Walmart',
        marketplaceIdHint: r.div([
            'https://www.walmart.com/ip/product-name/',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://www.walmart.com/ip/Super-Cool-Product/',
                r.b('158570758'),
            ]),
        ]),
        marketplaceUrlHint: 'https://www.walmart.com/ip/Super-Cool-Product/158570758',
        productType: 'product',
        reviewURL: (listing) => listing?.get('marketplaceId') && `https://www.walmart.com/reviews/write-review?productId=${listing?.get('marketplaceId')}`,
        value: 'https://walmart.com',
    },
    {
        label: 'Target',
        marketplaceIdHint: r.div([
            'https://www.target.com/p/product-name/-/A-',
            r.b('marketplaceId'),
            '?preselect=...',
            r.br(),
            r(Small, [
                'i.e. https://www.target.com/p/Super-Cool-Product/-/A-',
                r.b('78259823'),
                '?preselect=...'
            ]),
        ]),
        marketplaceUrlHint: 'https://www.target.com/p/Super-Cool-Product/-/A-78259823',
        productType: 'product',
        reviewURL: (listing) => listing?.get('marketplaceId') && `https://www.target.com/product/${listing?.get('marketplaceId')}/add-review?lnk=pdp`,
        value: 'https://target.com',
    },
    {
        label: 'Ebay',
        marketplaceIdHint: r.div([
            'https://www.ebay.com/itm/product-name/',
            r.b('marketplaceId'),
            '?_trkparms=...',
            r.br(),
            r(Small, [
                'i.e. https://www.ebay.com/itm/Super-Cool-Product/',
                r.b('173582487091'),
                '?_trkparms=...'
            ]),
            r.br(), r.br(),
            'Or use the ',
            r.b('eBay item number'),
            ' on the tab \'Description\'',
        ]),
        marketplaceUrlHint: 'https://www.ebay.com/itm/Super-Cool-Product/173582487091',
        productType: 'product',
        reviewURL: (listing) => listing?.get('marketplaceId') && `https://www.ebay.com/urw/write-review/itm/${listing?.get('marketplaceId')}`,
        value: 'https://ebay.com',
    },
    {
        label: 'Etsy',
        marketplaceIdHint: r.div([
            'https://www.etsy.com/listing/',
            r.b('marketplaceId'),
            '/product-name',
            r.br(),
            r(Small, [
                'i.e. https://www.etsy.com/listing/',
                r.b('844766850'),
                '/Super-Cool-Product',
            ]),
        ]),
        marketplaceUrlHint: 'https://www.etsy.com/listing/844766850/Super-Cool-Product',
        productType: 'product',
        reviewURL: 'https://www.etsy.com/your/purchases/',
        value: 'https://etsy.com',
    },
    {
        label: 'Best Buy',
        marketplaceIdHint: r.div([
            'https://www.bestbuy.com/site/reviews/submission_2/',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://www.bestbuy.com/site/reviews/submission_2/',
                r.b('6443995'),
            ]),
            r.br(), r.br(),
            'Or use ',
            r.b('SKU'),
            ' number under the name of product',
        ]),
        marketplaceUrlHint: 'https://www.bestbuy.com/site/super-cool-product/6473265.p?skuId=6473265',
        productType: 'product',
        reviewURL: (listing) => listing?.get('marketplaceId') && `https://www.bestbuy.com/site/reviews/submission_2/${listing?.get('marketplaceId')}`,
        value: 'https://bestbuy.com',
    },
    {
        label: 'New Egg',
        marketplaceIdHint: r.div([
            r.img({ src: NewEggHint }),
        ]),
        marketplaceUrlHint: 'https://www.newegg.com/super-cool-product/p/2HD-0014-00002?Item=9SIAAAG6HN5456',
        productType: 'product',
        reviewURL: (listing) => listing?.get('marketplaceId') && `https://secure.newegg.com/FeedBack/RateProduct.aspx?Item=${listing?.get('marketplaceId')}`,
        value: 'https://newegg.com',
    },
    {
        label: 'Home Depot',
        marketplaceIdHint: r.div([
            'https://www.homedepot.com/p/product-name/',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://www.homedepot.com/p/Super-Cool-Product/',
                r.b('207207033'),
            ]),
            r.br(), r.br(),
            'Or use ',
            r.b('\'Internet #\''),
            ' above product images',
        ]),
        marketplaceUrlHint: 'https://www.homedepot.com/p/Super-Cool-Product/207207033',
        productType: 'product',
        reviewURL: 'https://www.homedepot.com/order/view/summary',
        value: 'https://homedepot.com',
    },
    {
        label: 'Lowes',
        marketplaceIdHint: r.div([
            'https://www.lowes.com/pd/product-name/',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://www.lowes.com/pd/Super-Cool-Product/',
                r.b('3172675'),
            ]),
        ]),
        marketplaceUrlHint: 'https://www.lowes.com/pd/Super-Cool-Product/3172675',
        productType: 'product',
        reviewURL: (listing) => `${listing?.get('url')}/write-a-review`,
        value: 'https://lowes.com',
    },
    {
        label: 'Google Play Store',
        marketplaceIdHint: r.div([
            'https://play.google.com/store/apps/details?id=',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://play.google.com/store/apps/details?id=',
                r.b('com.example.app'),
            ]),
        ]),
        marketplaceUrlHint: 'https://play.google.com/store/apps/details?id=com.example.app',
        productType: 'app',
        reviewURL: (listing) => `${listing?.get('url')}`,
        reviewUrlHint: 'User has to go to the app in the Google Play Store and have the app installed',
        value: 'https://play.google.com',
    },
    {
        label: 'Chrome Web Store',
        marketplaceIdHint: r.div([
            'https://chrome.google.com/webstore/detail/product-name/',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://chrome.google.com/webstore/detail/cool-product/',
                r.b('dmghijesimdbdkbepgbldicpjgfkceaj'),
            ]),
        ]),
        marketplaceUrlHint: 'https://chrome.google.com/webstore/detail/cool-product/dmghijesimdbdkbepgbldicpjgfkceaj',
        productType: 'chrome extension',
        reviewURL: (listing) => `${listing?.get('url')}`,
        reviewUrlHint: 'User has to go to the chrome store with the app installed and click write a review',
        value: 'https://chrome.google.com/webstore/category/extensions',
    },
    {
        label: 'Apple App Store',
        marketplaceIdHint: r.div([
            'https://apps.apple.com/us/app/app-name/',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://apps.apple.com/us/app/app-name/',
                r.b('id1080745017'),
            ]),
        ]),
        marketplaceUrlHint: 'https://apps.apple.com/us/app/app-name/id1080745017',
        productType: 'app',
        reviewURL: (listing) => `${listing?.get('url')}`,
        reviewUrlHint: 'User has to go to the Apple App Store with the app installed and then can write a review',
        value: 'https://apps.apple.com/us/genre/ios/id36',
    },
    {
        label: 'Apple Podcasts',
        marketplaceIdHint: r.div([
            'https://podcasts.apple.com/us/podcast/podcast-name/',
            r.b('marketplaceId'),
            r.br(),
            r(Small, [
                'i.e. https://podcasts.apple.com/us/podcast/cool-podcast/',
                r.b('id74839404'),
            ]),
        ]),
        marketplaceUrlHint: 'https://podcasts.apple.com/us/podcast/cool-podcast/id74839404',
        productType: 'podcast',
        reviewURL: (listing) => `${listing?.get('url')}`,
        reviewUrlHint: 'User has to use an iPhone, iPad or Mac with the Apple Podcasts App installed to leave a review',
        value: 'https://podcasts.apple.com/us/genre/podcasts/id26',
    },
    {
        label: 'Another Website',
        value: 'custom',
    }
];

// Other sites the people may want reviews from
export const reviewPlatforms = [
    {
        hint: 'trustpilot',
        label: 'trustpilot',
        value: 'trustpilot',
    },
    {
        hint: 'sitejabber',
        label: 'sitejabber',
        value: 'sitejabber',
    },
    {
        hint: 'g2',
        label: 'g2',
        value: 'g2',
    },
    {
        hint: 'capterra',
        label: 'capterra',
        value: 'capterra',
    },
    {
        hint: 'yelp',
        label: 'yelp',
        value: 'yelp',
    },
    {
        hint: 'google maps',
        label: 'googlemaps',
        value: 'googlemaps',
    },
    {
        hint: 'facebook',
        label: 'facebook',
        value: 'facebook',
    },
];
